<template>
    <div class="admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="top_filters_area">
        <div class="places_search">
            <b-form-input
                    v-model="newLink"
                    placeholder="New link"
                    class="search_places"
            ></b-form-input>
            <button @click="createNewLink()">Create link</button>
        </div>
        </div>
        <b-list-group class="links_list" id="places_list" @scroll="onListScrolled">
            <b-list-group-item v-for="(item, index) in links" :key="index" :id="`link-${index}`"
                               class="link-item">
                <div class="link_header">
                    <div class="link_id">{{item.id}}</div>
                    <input type="text" v-model="item.url" :disabled="activeLinkId !== item.id"
                           :id="`original_link_md-input-${item.id}`"/>
                    <button @click="onLinkClick(item)" v-if="activeLinkId != item.id">Edit</button>
                    <button @click="onSaveLinkClick(item)"
                            v-if="activeLinkId == item.id && item.originalLink != item.url">Save
                    </button>
                </div>
                <div class="place_uid">
                    <input type="text" :value="item.short_url" :id="`link_md-input-${item.id}`">
                    <button @click="copyLink(item)">Copy</button>
                </div>
                <div class="control-panel">
                    <div @click.stop="onSaveLinkClick(item)" class="control-panel-item"
                         v-if="activeLinkId == item.id && item.originalLink != item.url">
                        <i class="fas fa-save"></i>
                    </div>
                    <div @click.stop="onDeleteLinkClick(item)" class="control-panel-item delete-place-icon">
                        <i class="fas fa-trash-alt"></i>
                    </div>
                </div>

            </b-list-group-item>
            <infinite-loading :identifier="infiniteLinks" @infinite="loadLinks">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </b-list-group>
        <b-modal v-model="linkAddedSuccess.show" content-class="custom-modal organization-settings"
                 @show="onLinkAddedPopupShown">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="cancelAddedSuccessPopup()"></span>
            </template>
            <h5 class="mb-4">New short link created</h5>

            <b-input-group class="mt-3 justify-content-between align-items-center">
                <textarea id="new_link_ta">{{linkAddedSuccess.item.short_url}}</textarea>
                <button @click="copyNewLink()">Copy</button>
            </b-input-group>
            <template v-slot:modal-footer>
                <b-button variant="primary" @click="cancelAddedSuccessPopup()">
                    Ok
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex";
    import InfiniteLoading from "vue-infinite-loading";
    import customModalDialog from '@/components/widgets/customModalDialog';
    import errorMixin from '@/mixins/errorMixin';
    import adminStickyHeaderMixin from "@/mixins/adminStickyHeaderMixin";
    import adminPageMixin from "@/mixins/adminPageMixin";


    export default {
        name: 'landingQuestions',
        mixins: [errorMixin, adminStickyHeaderMixin, adminPageMixin,],
        components: {
            InfiniteLoading,
            customModalDialog
        },

        data() {
            return {
                newLink: '',
                infiniteLinks: 0,
                page: 1,
                links: [],
                loadingAction: false,
                customModalSettings: {},
                linkAddedSuccess: {
                    show: false,
                    item: {}
                },
                activeLinkId: null,
            }
        },

        props: ['infinity'],

        watch: {
            infinity(val) {
                this.page = 1
                this.infiniteLinks += 1
            }
        },

        computed: {
            ...mapState({
                accounts: state => state.closeAccount.accounts
            })
        },
        mounted() {
            this.initAdminPage()
            this.refreshAll()
        },
        methods: {

            ...mapActions({
                getShortLinks: 'shortLinks/getShortLinks',
                addShortLink: 'shortLinks/addShortLink',
                editShortLink: 'shortLinks/editShortLink',
                deleteShortLink: 'shortLinks/deleteShortLink',
            }),

            ...mapMutations({
                setMessageModel: 'setMessageModel',
            }),

            async refreshAll() {

            },

            async loadLinks(stateInf) {
                try {
                    this.loadingAction = true
                    const response = await this.getShortLinks({
                        page: this.page
                    })
                    if(this.page == 1) {
                        this.links = []
                    }
                    this.page += 1;
                    let items = response.collection
                    for (let i = 0; items.length > i; i++) {
                        items[i].originalLink = items[i].url
                    }
                    items.forEach((item) => {
                        this.links.push(item)
                    })
                    if (stateInf) {
                        if (this.links.length === 10) {
                            stateInf.loaded();
                        } else {
                            stateInf.complete();
                        }
                    }
                } catch (e) {
                    console.log(e)
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.loadingAction = false
                }
            },

            async createNewLink() {
                try {
                    if (this.newLink.trim().length == 0) {
                        this.setMessageModel({
                            msg: 'Please enter link',
                            duration: 1000
                        })
                        return
                    }
                    const response = await this.addShortLink({
                        url: this.newLink,
                    });
                    this.newLink = ''
                    this.linkAddedSuccess.item = response.link
                    this.linkAddedSuccess.show = true
                    this.infiniteLinks += 1
                } catch (e) {
                    console.log(e)
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },
            async onSaveLinkClick(item) {
                try {
                    const response = await this.editShortLink({
                        id: item.id,
                        url: item.url,
                    });
                    this.activeLinkId = null
                    this.setMessageModel({
                        msg: 'Link url changed',
                        duration: 1000
                    })
                } catch (e) {
                    console.log(e)
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },

            async onDeleteLinkClick(item) {
                this.customModalSettings = {
                    message: `Are you sure to delete this link? ${item.url}`,
                    onOkHandler: this.deleteLink.bind(null, item),
                    showCancelButton: true,
                    okButtonText: `Delete`,
                    cancelButtonText: `Cancel`
                }
            },
            async deleteLink(item) {
                try {
                    const response = await this.deleteShortLink({
                        id: item.id
                    });
                    this.infiniteLinks += 1
                    this.setMessageModel({
                        msg: 'Link deleted',
                        duration: 1000
                    })
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                }
            },
            onLinkClick(item) {
                this.activeLinkId = item.id
                let originalField = document.getElementById(`original_link_md-input-${item.id}`)
                originalField.disabled = false
                originalField.focus()
            },
            cancelAddedSuccessPopup() {
                this.linkAddedSuccess.item = {}
                this.linkAddedSuccess.show = false
            },
            selectNewLinkText() {
                const textarea = document.getElementById('new_link_ta')
                textarea.select();
            },
            onLinkAddedPopupShown() {
                setTimeout(() => {
                    this.selectNewLinkText()
                }, 300);
            },
            copyNewLink() {
                this.selectNewLinkText()
                try {
                    return document.execCommand("copy");
                } catch (ex) {
                    this.setMessageModel({
                        msg: 'Failed to copy. Please use CTRL+C to copy',
                        duration: 1000
                    })
                } finally {

                }
            },
            copyLink(item) {
                const field = document.getElementById(`link_md-input-${item.id}`)
                field.select();
                try {
                    return document.execCommand("copy");
                } catch (ex) {
                    this.setMessageModel({
                        msg: 'Failed to copy. Please use CTRL+C to copy',
                        duration: 1000
                    })
                } finally {

                }
            },
            onListScrolled(element) {
                this.fixStickyHeader(element.srcElement.scrollTop)
            },

        }

    }
</script>

<style scoped>

    .links_list {
        max-height: calc(100vh - 62px);
        overflow: auto;
        margin-bottom: 0;
        padding-bottom: 5em;
    }

    .link_header {
        display: flex;
        flex-direction: row;
    }

</style>
